/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import {
  IApplyAdditionalTimeDraftsRequest,
  IAdditionalTimeRequest,
} from '../models/additional-time.model';
import { IWorkOverviewMatrixRequest } from '../models/work-overview-matrix.model';

export class CreateAdditionalTime {
  static readonly type = '[AdditionalTimes] Create Additional Time';
  constructor(
    public additionalTime: IAdditionalTimeRequest,
    public userIdFromDetails?: string,
    public workOverviewFilter?: IWorkOverviewMatrixRequest
  ) {}
}

export class ApproveAdditionalTime {
  static readonly type = '[AdditionalTimes] Approve Additional Time';
  constructor(
    public ids: string[],
    public comment: string
  ) {}
}

export class DenyAdditionalTime {
  static readonly type = '[AdditionalTimes] Deny Additional Time';
  constructor(
    public ids: string[],
    public comment: string
  ) {}
}

export class UpdateAdditionalTime {
  static readonly type = '[AdditionalTime] Update Additional Time';
  constructor(
    public request: IAdditionalTimeRequest,
    public userIdFromDetails: string,
    public workOverviewFilter?: IWorkOverviewMatrixRequest
  ) {}
}

export class DeleteAdditionalTime {
  static readonly type = '[AdditionalTime] Delete Additional Time';
  constructor(
    public id: string,
    public userIdFromDetails: string,
    public workOverviewFilter?: IWorkOverviewMatrixRequest
  ) {}
}

export class LoadAdditionalTimeRequests {
  static readonly type = '[AdditionalTimes] Load Additional Time Requests';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAdditionalTimeById {
  static readonly type = '[AdditionalTimes] Load Additional Time By Id';
  constructor(public id: string) {}
}

export class LoadAdditionalTimeHistory {
  static readonly type = '[AdditionalTimes] Load Additional Time History';
  constructor(public filter?: MainTableFilterModel) {}
}

export class ApplyAdditionalTimeDrafts {
  static readonly type = '[AdditionalTimes] Apply Additional Time Drafts';
  constructor(public request: IApplyAdditionalTimeDraftsRequest) {}
}
